module.exports = __webpack_public_path__ + "img/maik.968770d8.jpg";